import { Box, Center, Spinner } from '@chakra-ui/react';
import { DITable } from 'plugins/DITable';
import TablePagination from 'plugins/DITable/Pagination';
import useSalesData from './useSalesData';
import SalesDataToolbar from './Toolbar';

const SalesDataTab = () => {
    const {
        tableInstance,
        isSalesDataLoading,

    } = useSalesData();
    return (
        <Box mt="16px">
            <SalesDataToolbar
                {...{
                    tableInstance,
                }}
            />
            {isSalesDataLoading ? (
                <Center w="100%" h="200px" bg="white" border="1px solid" borderColor="gray.100">
                    <Spinner />
                </Center>
            ) : (
                <>
                    <DITable {...tableInstance} isPagination isHeaderFixed />
                    <TablePagination tableInstance={tableInstance} />
                </>
            )}
        </Box>
    );
};

export default SalesDataTab;
